<template>
  <div>
    <el-select
      v-model="value"
      :disabled="disabled"
      :multiple="multiple"
      :placeholder="placeholder"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
const axios = require("axios");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      value: "", // 当前被选择的渠道的id或者id集合，即实际的类型既可能是一个字符串也可能是一个数组
      availableChannels: [], // 所有可用的渠道
    };
  },

  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },

    // 是否支持多选
    multiple: {
      type: Boolean,
      default: false,
    },

    // 是否支持选择“全渠道”
    enableFullChannels: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options() {
      let options = [];

      for (let c of this.availableChannels) {
        if (c.id == "all" && !this.enableFullChannels) {
          continue;
        }

        options.push({
          id: c.id,
          name: c.name,
        });
      }

      return options;
    },
  },

  created() {
    this.loadAvailableChannels();
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 清除选择
     */
    clear() {
      this.value = "";
    },

    /**
     * 查询渠道集合
     */
    async loadAvailableChannels() {
      this.availableChannels = await bizutil.loadAvailableChannels();

      // 抛出准备就绪事件
      this.$emit("ready");
    },
  },
};
</script>